import React, { Component } from 'react';
import _ from 'lodash';
import { func, object } from 'prop-types';
import Table from '../../../../components/LazyWidgets/Table';
import CircleText from '../../../../components/LazyWidgets/CircleText';
import Tooltip from '../../../../components/LazyWidgets/Tooltip';
import DonutChart from '../../../../components/LazyWidgets/DonutChart';
import s from '../overviewWidget.module.css';
import { REVISION_COLORS } from '../../../util/constants';
import { getConfigObject } from '../../../util/config';

class RevisionPlansCard extends Component {

  static propTypes = {
    onTabChange: func,
    data: object,
  };

  static getDerivedStateFromProps(newProps, prevState) {
    if (!_.isEqual(prevState.data, newProps.data)) {
      if (newProps.data) {
        return ({
          data: newProps.data,
          totalTasks: newProps.data.totalTasks,
          topDraftsGoals: newProps.data.topGoalsByTask,
          topGoalsRepresentation: `${newProps.data.totalTopGoalsTasks}/${newProps.data.totalTasks}`,
          numPlansNotStarted: newProps.data.notStarted,
          nextDraftDueDate: newProps.data.nextDraftDue || null,
          nullState: newProps.data.topGoalsByTask.length === 0,
        });
      }
      return ({
        nullState: true,
      });
    }
    return null;
  }

  constructor(props) {
    super(props);
    const tableStyle = [
      {
        row: 'styledRow',
        cells: [
          { accessor: 'goal', alignment: 'left' },
          { accessor: 'tasks', alignment: 'center' },
        ],
      },
    ];
    const tableColumns = [
      {
        accessor: 'goal',
        Header: 'Goal Title',
        cell: item => this.getCircleColor(item, this.getColors()),
        className: 'styledRow',
      },
      {
        accessor: 'tasks',
        Header: 'Goal Number of uses',
        cell: item => item.tasks,
        className: 'styledRow',
      },
    ];

    if (props.data) {
      this.state = {
        data: props.data,
        tableColumns,
        tableStyle,
        totalTasks: props.data.totalTasks,
        topDraftsGoals: props.data.topGoalsByTask,
        topGoalsRepresentation: `${props.data.totalTopGoalsTasks}/${props.data.totalTasks}`,
        numPlansNotStarted: props.data.notStarted,
        nextDraftDueDate: props.data.nextDraftDue || null,
        nullState: props.data.topGoalsByTask.length === 0,
      };
    } else {
      this.state = {
        nullState: true,
      };
    }
    this.getCircleColor = this.getCircleColor.bind(this);
  }

  getDays(dueDate) {
    const today = new Date();
    const diff = new Date(dueDate).getTime() - today.getTime();
    return diff > 0 ? Math.round((((diff / 1000) / 60) / 60) / 24) : 0;
  }

  getCircleColor(item) {
    return (
      <CircleText
        className={s.circleTextContainer}
        circleColor={this.getColors()[this.state.topDraftsGoals.indexOf(item)]}
        alignment="left"
        circleSize={14}
        circleAriaHidden
      >
        <Tooltip trigger={<p className={s.goalTitle}>{item.goal}</p>} content={item.goal} on="hover" position="bottom center" />
      </CircleText>
    );
  }

  getColors() {
    return [
      REVISION_COLORS.MOST_USED,
      REVISION_COLORS.STRONGLY_USED,
      REVISION_COLORS.AVERAGE_USED,
      REVISION_COLORS.LESS_USED,
      REVISION_COLORS.LEAST_USED,
    ];
  }

  getSlices(goals) {
    const slices = [];
    goals.forEach((item) => {
      slices.unshift({
        value: item.tasks,
        color: this.getColors()[goals.indexOf(item)],
      });
    });
    return slices;
  }

  handleNotStartedClick = () => {
    this.props.onTabChange('reports/type/revision-plans-not-started');
  };

  revisionPlansNotstarted = (notStartedRevisionPlans, nextDraftDue) => {
    const DASHBOARDS_ENABLED_REVISION_PLANS_NOT_STARTED = getConfigObject().DASHBOARDS_ENABLED_REVISION_PLANS_NOT_STARTED || false;
    if (DASHBOARDS_ENABLED_REVISION_PLANS_NOT_STARTED && notStartedRevisionPlans) {
      const nextDraftDays = this.getDays(nextDraftDue);
      const nextDraftDaysString = `Next draft due in ${nextDraftDays} ${nextDraftDays !== 1 ? 'days' : 'day'}`;
      return (
        <div>
          <div className={s.notStarted}>
            <span>Revision Plans Not Started</span>
            <button className={s.numberOfNotStarted} role="link" onClick={this.handleNotStartedClick}>
              {notStartedRevisionPlans}
            </button>
          </div>
          {nextDraftDue && <span className={s.nextDraft}>{nextDraftDaysString}</span>}
        </div>
      );
    }
    return null;
  };

  render() {
    const DASHBOARD_ENABLED_REVISION_PLAN_WIDGET = getConfigObject().DASHBOARD_ENABLED_REVISION_PLAN_WIDGET || false;

    const {
      tableColumns,
      tableStyle,
      topDraftsGoals,
      topGoalsRepresentation,
      numPlansNotStarted,
      nextDraftDueDate,
      totalTasks,
      nullState,
    } = this.state;
    const topGoalsPlural = !topDraftsGoals || topDraftsGoals.count !== 1;
    if (DASHBOARD_ENABLED_REVISION_PLAN_WIDGET) {
      return (
        <div className={s.revisionPlansContainer}>
          <div className={s.textDescription}>{`Top Draft ${topGoalsPlural ? 'Goals' : 'Goal'} with Revision tasks`}</div>
          {!nullState && <div>
            <div className={s.chartContainer}>
              <DonutChart slices={this.getSlices(topDraftsGoals)} aria-hidden />
            </div>
            <div className={s.tableContainer}>
              <Table
                className={s.revisionsTable}
                data={topDraftsGoals}
                columns={tableColumns}
                styling={tableStyle}
                sortColumn="count"
                sortDirection="desc"
                minWidth={130}
              />
              <span className={s.represents}>Represents {topGoalsRepresentation} Revision {(totalTasks !== 1) ? 'Tasks' : 'Task'}</span>
            </div>
            {this.revisionPlansNotstarted(numPlansNotStarted, nextDraftDueDate)}
          </div>}
          {nullState && <div className={s.nullState}>
            No revision plans have been created
          </div>}
        </div>
      );
    }
    return null;
  }
}

export default RevisionPlansCard;
